export const SLOT_TYPE_BOOKING_PORTIONS = ['full', 'range'] as const;

export type SlotTypeBookingPortion = (typeof SLOT_TYPE_BOOKING_PORTIONS)[number];

export type SlotTypePortions = { readonly fullDay: boolean; readonly timeRange: boolean };

const TIME_RANGE_PORTIONS: readonly unknown[] = ['range', 'hours', 'fraction'];

export function slotTypePortionsOf(config: Record<string, unknown> | undefined): SlotTypePortions {
  const allowed = config?.['allowedPortions'];
  if (!Array.isArray(allowed) || allowed.length === 0) return { fullDay: true, timeRange: true };
  return {
    fullDay: allowed.includes('full'),
    timeRange: allowed.some(portion => TIME_RANGE_PORTIONS.includes(portion)),
  };
}
